var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { setDefaultStyle } from "apparatus/draw";
import { Segments } from "apparatus/library/common";
import { Arrays } from "ext/array";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let StemmedGlass = class StemmedGlass {
    render({ size, spout }) {
        const anglingRatio = 0.3; // Size will refer to the height
        const glass = new Path(Segments([[size * anglingRatio + 5, -size]], [[5, 0], , [-2, 5]])).mirrorX();
        const pivot = glass.bounds.center;
        if (spout) {
            // Draw spout
            glass.segments[0].point.x -= 7 * anglingRatio;
            glass.segments[0].point.y += 7;
            glass.insertSegments(0, Segments([[size * anglingRatio + 11, -size], , [-3, 0]]));
        }
        const liquidMask = glass.clone();
        const stand = new Path(Segments([[5, 0], , [-2, 5]], [[size * anglingRatio + 1, 3 + size / 20]])).mirrorX();
        const graphic = new Group([glass, stand]);
        setDefaultStyle(graphic);
        return {
            graphic,
            pivot,
            liquidMask,
            liquidMaskOpening: { end: liquidMask.segments[0].point, start: Arrays.last(liquidMask.segments).point },
            hitShape: graphic.rectHitShape(),
            snapping: [
                graphic.placeable()
            ]
        };
    }
};
StemmedGlass.properties = {
    label: "Stemmed Glass",
    canContainLiquids: true,
    pourable: true,
    flippable: true,
    defaultAppearance: {
        size: 50,
        spout: false,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 40, max: 100, // Looks a bit weird under 40, may need tweaking.
        },
        { spec: "checkbox", key: "spout", label: "Spout" }
    ],
};
StemmedGlass = __decorate([
    staticImplements()
], StemmedGlass);
export { StemmedGlass };
